import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScreeningFlow from '../screening/ScreeningFlow';

function PublicScreening() {
  const navigate = useNavigate();
  return (
    <ScreeningFlow
      mode="public"
      onRegister={() => navigate('/register')}
      onLogin={() => navigate('/login')}
    />
  );
}

export default PublicScreening;